// src/components/DocumentUploadPopup.js
import React, { useEffect, useState, useRef } from 'react';
import { AppConstant } from '../../../Assests/AppConstant';
import SSPopup from '../Popup/SSPopup/SSPopup';
import CustomButtonSS from '../CustomButton/CustomButtonSS';
import _ from 'lodash-es';

import CustomFieldWithTtileSS from '../CustomField/CustomFieldWithTtileSS';
import { useDispatch } from 'react-redux';
import { sagaActions } from '../../../../sagas/sagaActions';
import CustomTimePicker from '../CustomTimePicker/CustomTimePicker';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { smartScheduleSelector } from '../../../../redux/reducers/reducerSlices/SmartScheduleReducer';


const initialErrors={
    date:'',
    time:'',
}

const ApptCompletionPopup = (props) => {
    const { themeSelected, showModal, setCloseModal, initateLoading ,poDetails , maxDate, minDate,editData,setEditData} = props;
    const { completeManualAppointmentResponse } = useSelector(smartScheduleSelector)
    const dispatch = useDispatch()
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false)
    const currentDate = moment().format(AppConstant.commonStrings.YYYY_MM_DD);
    const currentTime = moment().format(AppConstant.commonStrings.HH_mm_dateFormat);
    const [inputs,setInputs]=useState({
            date:currentDate,
            time: currentTime,
    
        })

    const [errors,setErrors]  = useState(initialErrors)

    const [dirty,setDirty]  = useState({
        date:false,
        time:false,
 
    })

    useEffect(()=>{
        if(editData){
            setInputs({
                date:editData.ManualAppointmentEndDate ?  moment(editData.ManualAppointmentEndDate).utc().format(AppConstant.commonStrings.YYYY_MM_DD) : '',
                time: editData.ManualAppointmentEndTime ? moment(editData.ManualAppointmentEndTime).utc().format(AppConstant.commonStrings.HH_mm_dateFormat) : ''
            })
        }
    },[editData])

    useEffect(()=>{
        return ()=>{
            dispatch({type:sagaActions.CLEAR_COMPLETE_MANUAL_APPOINTMENT_RESPONSE})
        }
    },[])

    /**
     * useEffect to show and hide modal
     */
    useEffect(() => {
        setShow(showModal)
    }, [showModal])

    /**
     * useEffect to for loader
     */
    useEffect(() => {
        setLoading(initateLoading)
    }, [initateLoading])
    
    useEffect(()=>{
        if (completeManualAppointmentResponse ) {
        handleClose()
        setEditData(null)
        }
    },[completeManualAppointmentResponse])


    /**
     * fuction to close modal
     */
    const handleClose = () => {
        setShow(false)
        setCloseModal(false)
        dispatch({ type: sagaActions.SET_SS_SELECTED_PO_FOR_APPT, payload: [] })

    };
    
    let handleChange = (data, name) => {
        if (typeof data === 'object') {
            data = data.toString();
        }
        setInputs((inputs) => ({ ...inputs, [name]: data }));

    };

    const handleErrors = (name) => {
        setDirty((dirty) => ({ ...dirty, [name]: true }));
        validate(name);
    };

    const validate=(name) => {

        let valid=true
        let errorData={...initialErrors}
        if (!inputs.date) {
            errorData.date=AppConstant.help.required
            valid=false
        }
        if (!inputs.time && inputs.time!=="00:00") {
            errorData.time=AppConstant.help.required
            valid=false
        }
        setErrors(errorData)
        return valid
    }

    const submitForm = () => {

        let dirtyData = dirty;
        Object.keys(dirty).forEach((control) => {
            dirtyData[control] = true;
        });
        
        
        setDirty(dirtyData);
        if (validate() ) {
            const endDate = moment(`${inputs.date} ${inputs.time}`).format(AppConstant.commonStrings.YYYY_MM_DD_T_HH_mm_ss)
            const payload = {
                "IDWarehouse": poDetails?.IDWarehouse,
                "IDDock": poDetails?.IDDock,
                "PoNumber": poDetails.PoNumber,
                "ReceivingZipCode": poDetails.ReceivingZipCode,
                "ManualAppointmentEndDate": endDate,
                "ManualAppointmentEndTime": endDate
        }
            dispatch({type:sagaActions.COMPLETE_MANUAL_APPOINTMENT,payload:payload})
     
        }
    };

 const DateAndTimeForm = () =>{
    return(

                  <div className='d-flex flex-column w-100 gap-2'>
                          <div className='d-flex justify-content-between mb-2'>
                        <div className='carrier-po-key'>
                            <i className="fa-solid fa-cube" ></i> <span className='ms-1'>{_.upperCase(poDetails.LoadType) === 'INBOUND'? AppConstant.poManagement.tableHeader.po: AppConstant.poManagement.tableHeader.so}</span>
                        </div>
                        <div className='carrier-po-value text-truncate w-75' title={poDetails?.PoNumber}>{poDetails?.PoNumber}</div>
                    </div>
            <CustomFieldWithTtileSS    
              type={"date"}
              showError={
                dirty["date"] && errors["date"][0]
                  ? errors["date"]
                  : ""
              }
              name={"date"}
              value={inputs["date"] ? inputs["date"] : ""}
              handleErrors={handleErrors}
              title={"Date"}
              required={true}
              onChange={(data, name) => handleChange(data, name)}
              disabledField={false}
              //customDatePickerConfig={{startDate:minDate,endDate:maxDate}}
              
            />
                <CustomTimePicker
                name={'time'}
                showError={
                    dirty["time"] && errors["time"][0]
                      ? errors["time"]
                      : ""
                  }
                  value={inputs["time"] ? inputs["time"] : ""}
                onChange={(data, name) => handleChange(data, name)}
                timeFormat="24h"
                required={true}
                />
                 <div className="d-flex justify-content-end my-2">
            <CustomButtonSS
                isLoading={false}
                title={"Close"}
                className={"btn-unstyled"}
                onClick={handleClose}
              />
              <CustomButtonSS
                isLoading={loading}
                title={"Save"}
                className={"btn-styled"}
                onClick={submitForm}
              />
            </div>
            </div>

    )
 }

    


    const ApptCompletionModalObj = {
        id: "ApptCompletionModalObj",
        modalLabel: "ApptCompletionModalObj",
        showClose: false,
        showfooter: false,
        showHeader: true,
        sendDriverNotification: false,
        modalSize: "md",
        title: "Date And Time",
        bodyText: DateAndTimeForm(),
        subText: "",
        keyboard: false,
        backdrop: "static",
        alignType: 'start',
        type: 'info',
        footerBtn: {
            btn1: {
                show: false,
                text: AppConstant.commonStrings.yes,
            },
            btn2: {
                show: false,
                text: AppConstant.commonStrings.no,
            },
        },
    }

    return (
        <>
            {show ? <SSPopup {...ApptCompletionModalObj} popupBtnHandler={() => { }} closepopup={handleClose} themeSelected={themeSelected} showModal={show} /> : ''}

        </>
    );
};

export default ApptCompletionPopup;
